import { COVIDINSURANCE, INSURANCE, SUSTAINABILITY, INVIA_TYPE_CAN_EXCLUDED, INVIA_TYPE_CAN_INCLUDED, INVIA_TYPE_RES_EXCLUDED, INVIA_TYPE_RES_INCLUDED } from '../../../components/models.js';
const productType = {
  [INVIA_TYPE_CAN_INCLUDED]: 'cancellationIncluded',
  [INVIA_TYPE_CAN_EXCLUDED]: 'cancellationExcluded',
  [INVIA_TYPE_RES_INCLUDED]: 'reservationIncluded',
  [INVIA_TYPE_RES_EXCLUDED]: 'reservationExcluded',
  [INSURANCE]: 'insurance',
  [COVIDINSURANCE]: 'covidInsurance',
  [SUSTAINABILITY]: 'sustainability'
};
export const useParsedProducts = products => {
  return products.map(product => ({
    ...product,
    type: productType[product.type]
  }));
};